/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useAddProductLot,
  useUpdateProductLot,
} from "../../../api/product-code-management/use-product-code";
import { useProductCodeByQR } from "../../../api/product-code-management/use-product-code-detail";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import Button from "../../../components/ui/Button/Button";
import { Dropdown } from "../../../components/ui/Dropdown/Dropdown";
import Modal from "../../../components/ui/Modal/Modal";
import QRForm from "./Section/QRForm";
import QRSmartFactory from "./Section/QRSmartFactory";
import TableDetailQR from "./Section/TableDetailQR";

const orderByOption = [
  {
    id: "LATEST",
    name: "최신순",
  },
  {
    id: "DATE_REGIST",
    name: "등록일순",
  },

  {
    id: "DATE_MANUFAC",
    name: "제조일자순",
  },

  {
    id: "DATE_EFFECTIVE",
    name: "유효일자순",
  },
];
const QRManagementDetailPage = () => {
  const { id, prodId } = useParams();
  const navigate = useNavigate();
  const { data } = useProductCodeByQR(prodId);
  const { mutate: addProductLot } = useAddProductLot();
  const { mutate: updateProductLot } = useUpdateProductLot();
  const productCodeQR = data?.data?.product;
  const [triggerCloseModal, setTriggerCloseModal] = useState(false);
  const [isEditForm, setIsEditForm] = useState(false);
  const [orderBy, setOrderBy] = React.useState("");

  useEffect(() => {
    if (triggerCloseModal === true) {
      setTriggerCloseModal(false);
      setIsEditForm(false);
    }
  }, [triggerCloseModal]);

  const handleToInventory = () => {
    navigate(`/product-management/inventory/${prodId}`);
  };

  const onChangeOrderBy = (id) => {
    setOrderBy(id);
  };

  const onEditForm = () => {
    setIsEditForm(true);
  };

  const handleBackToList = () => {
    navigate(`/product-management/code/${id}`);
  };

  const onSubmitProductLot = async (data) => {
    const payload = {
      ...data,
      productId: prodId,
      type: "MANUAL",
    };

    // const hasId = data?.id !== null;

    const editPayload = {
      ...payload,
      id: data?.id ?? id,
    };

    try {
      if (isEditForm) {
        await updateProductLot(editPayload);
      } else {
        await addProductLot(editPayload);
      }
      setTriggerCloseModal(true);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <TitlePage title="코드관리 > REF 관리 > QR 정보 관리" />
      <div className="mt-3">
        <h2 className="text-black text-[14px] font-bold">상품정보</h2>
        <div className="mt-[12px]">
          <div className="flex items-center justify-between">
            <div className="w-1/2 h-[216px]">
              <div className="flex border-x border-t border-primary-grey ">
                <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                  상품번호
                </div>
                <div className="bg-white p-3 w-full">
                  {productCodeQR?.productGroup?.productNo}
                </div>
              </div>
              <div className="flex border-x border-t border-primary-grey ">
                <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                  상품 그룹명
                </div>
                <div className="bg-white p-3 w-full">
                  {productCodeQR?.productGroup?.name}
                </div>
              </div>{" "}
              <div className="flex border-x border-t border-primary-grey ">
                <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                  상품명
                </div>
                <div className="bg-white p-3 w-full">{productCodeQR?.name}</div>
              </div>{" "}
              <div className="flex border-x border-t border-primary-grey ">
                <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                  REF(상품코드)
                </div>
                <div className="bg-white p-3 w-full">{productCodeQR?.ref}</div>
              </div>
              <div className="flex border-x border-t border-b border-primary-grey ">
                <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                  카테고리
                </div>
                <div className="bg-white p-3 w-full">
                  {productCodeQR?.productGroup?.productGroupCategory?.name}
                </div>
              </div>
            </div>
            <div className="w-1/2 h-[216px]">
              <div className="flex items-center border-y border-r border-primary-grey h-full">
                <div className="flex bg-input-grey border-r border-primary-grey w-[40%] p-3 h-full">
                  <span className="my-auto">이미지</span>
                </div>
                <div className="bg-white p-3 w-full">
                  <div className="w-[150px] h-[150px]">
                    <img
                      src={productCodeQR?.productGroup?.mainImage}
                      className="w-full h-full object-fit"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end w-full mt-[16px]">
            <Button
              onClick={handleBackToList}
              className="border border-title-black w-[80px]"
              text="목록"
            />
            <Modal
              maxWidth="max-w-[50rem]"
              width="[45rem]"
              hasCancel={false}
              description={
                <div className="p-1">
                  <h2 className="font-bold">※ 사용 방법 안내</h2>
                  <ol>
                    <li className="mt-1">
                      1. REF의 재고를 등록하기 위하여, QR 정보를 등록해야합니다.
                    </li>
                    <li className="mt-1">
                      2.{" "}
                      <span className="underline">
                        스마트팩토리 재고를 연동
                      </span>
                      하기 위한 방법 (구분 : 스마트팩토리 연동) <br />
                      (1) '스마트팩토리 연동 등록'을 눌러주세요.
                      <br />
                      (2) LOT 재고 연동 (스마트팩토리 연동) 팝업이 열리면,
                      연동여부가{" "}
                      <span className="text-[#FF0000]">'미연동'</span> 으로
                      되어져 있는 LOT 이하 정보를 확인 한 후,{" "}
                      <span className="text-[#FF0000]">'연동하기'</span>를
                      눌러주세요.
                      <br />
                      (3) LOT 정보 관리 화면에서 연동 된 '스마트팩토리 연동
                      재고'는 1회 연동하기 만으로 자동 업데이트 되어
                      '재고관리'에 입고수량이 등록됩니다.
                    </li>
                    <li className="mt-1">
                      3. <span className="underline">LOT 신규 생성</span> (구분
                      : 수동 등록)
                      <br />
                      (1) 스마트팩토리에 없는 LOT 정보일 경우,{" "}
                      <span className="text-[#FF0000]">
                        관리자가 직접 LOT 정보 (LOT, QR번호, 제조일자,
                        유효일자)를 등록
                      </span>
                      할 수 있습니다.
                      <br />
                      (2) LOT 신규 생성을 클릭하여, 항목에 정확한 값을
                      등록해주세요.
                      <br />
                      (3) LOT 신규 생성 된 LOT 재고는{" "}
                      <span className="underline">
                        '재고관리'에서 직접 재고를 입고처리
                      </span>{" "}
                      해야합니다.
                      <br />
                      (4) 해당 REF 상품의 재고관리`{">"}`재고 상세내역 화면에서
                      LOT 신규 생성 한 항목에{" "}
                      <span className="text-[#FF0000]">'LOT 재고 연동'</span>을{" "}
                      <span className="text-[#FF0000]">'연동하기'</span> 해야만,
                      입고처리 됩니다.
                    </li>
                    <li className="mt-1">
                      4. REF에 1개의 LOT가 연동될 경우, '상품관리`{">"}`상품정보
                      상세`{">"}`상품정보 변경' 화면에서 해당 REF는 삭제가
                      불가능합니다.
                      <br />
                      연동된 LOT 정보가 없는 REF에 한하여 삭제가 가능합니다.
                    </li>
                  </ol>
                </div>
              }
            >
              <Button
                className="border w-[95px] border-title-black"
                text="사용 방법 안내"
              />
            </Modal>
            <Button
              onClick={handleToInventory}
              className="border w-[120px] border-title-black"
              text="재고 상세내역 이동"
            />
            <Modal
              padding="p-7"
              width="w-[50rem]"
              maxWidth="w-[50rem]"
              title="LOT 상세정보 (스마트팩토리 연동)"
              hasClose={true}
              hasCancel={false}
              hasSubmit={false}
              description={
                <QRSmartFactory
                  onSubmit={onSubmitProductLot}
                  productCodeQR={productCodeQR}
                  handleToInventory={handleToInventory}
                />
              }
              triggerClose={triggerCloseModal}
            >
              <Button
                className="border w-auto border-primary-blue"
                text="스마트팩토리 연동 등록"
                primary
              />
            </Modal>
            <Modal
              padding="p-7"
              width="w-[50rem]"
              maxWidth="w-[50rem]"
              title="LOT 신규 생성 (수동 등록)"
              hasCancel={false}
              hasSubmit={false}
              rightTittle={
                <Modal
                  description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
                  onSubmit={() => setTriggerCloseModal(true)}
                >
                  <div className="cursor-pointer font-bold text-[14px]">X</div>
                </Modal>
              }
              closable={false}
              description={
                <QRForm
                  onSubmit={onSubmitProductLot}
                  productCodeQR={productCodeQR}
                />
              }
              triggerClose={triggerCloseModal}
            >
              <Button
                className="border border-primary-blue"
                text="+ LOT 신규 생성"
                primary
              />
            </Modal>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <div className="flex justify-between items-center">
          <h2 className="text-black text-[14px] font-bold">QR 정보</h2>

          <Dropdown
            width="w-24"
            placeholder="최신순"
            options={orderByOption}
            onClickItem={onChangeOrderBy}
            border="border-none"
            textColor="text-black"
          />
        </div>
        <div className="mt-[8px]">
          <TableDetailQR
            product={productCodeQR}
            productLots={productCodeQR?.productLots}
            onSubmitProductLot={onSubmitProductLot}
            productCodeQR={productCodeQR}
            setTriggerCloseModal={setTriggerCloseModal}
            triggerCloseModal={triggerCloseModal}
            isEditForm={isEditForm}
            setIsEditForm={setIsEditForm}
            onEditForm={onEditForm}
          />
        </div>
      </div>
    </div>
  );
};

export default QRManagementDetailPage;
